import { CircularProgress } from "@material-ui/core";
import React from "react";
import store from "src/store";
import { Input } from "./input";
import ValueOrChoose from "./value-or-choose";
import { useStepIndex } from "./step-index-context";

const CONSTS = require("shared/consts")

export default function ExpectedEventsDeclare({eventABI,eventIndex}) {
    var stepIndex=useStepIndex()
    let step = store.steps[stepIndex];
    let previousSteps = store.steps.filter((s, index) => index < stepIndex);

    const changeInput = (index, e) => {
        console.log("store.steps[stepIndex]['expected_events']", store.steps[stepIndex]['expected_events']);
        store.steps[stepIndex]['expected_events'][eventIndex]['expectedEventParameters'] = store.steps[stepIndex]['expected_events'][eventIndex]['expectedEventParameters'] || []
        let v = e.target ? e.target.value : e;
        if (typeof (v) != 'boolean') {
            if (v) {
                store.steps[stepIndex]['expected_events'][eventIndex]['expectedEventParameters'][index] = v;
            } else {
                store.steps[stepIndex]['expected_events'][eventIndex]['expectedEventParameters'].splice(index, 1);
            }
        } else {
            store.steps[stepIndex]['expected_events'][eventIndex]['expectedEventParameters'][index] = v;
        }
        store.updateStore()
    }

    return (
        <>
            <div css="
            margin-top: 20px;
            font-size:13px;
            "
            >
                {
                    (((eventABI?.inputs?.length > 0 && step.abiLoadingStatus == "ready") || step.abiLoadingStatus == "loading")) &&
                    (
                        <>
                            <Input
                                width="0%"
                                wrapperWidth="100%"
                                label={''}
                            >
                                <div>
                                    {step.abiLoadingStatus == "loading" &&
                                        <div css={`
                                    /* margin: 15px; */
                                    `}>
                                            <CircularProgress
                                                size={12}
                                            />
                                        </div>
                                    }

                                    {step.abiLoadingStatus == "ready" && eventABI?.inputs?.map((output, index) => (
                                        <div key={index} css={`
                                    /* margin: 15px; */
                                    `}>
                                            <ValueOrChoose
                                                //@ts-ignore
                                                width="100%"
                                                disabled={store.isReadOnly}
                                                wrapperWidth="100%"
                                                chooseValue=""
                                                label={
                                                    output.name ? output.name : "Parameter #" + (index + 1)
                                                }
                                                value={(store.steps[stepIndex]['expected_events'][eventIndex] && store.steps[stepIndex]['expected_events'][eventIndex]['expectedEventParameters']?.[index]) || ""}
                                                onChange={changeInput?.bind(null, index)}
                                                type={output.type}
                                                onChoose={() => { }}
                                                list={
                                                    output.type == "address"
                                                        ? //@ts-ignore
                                                        previousSteps
                                                            .filter(s => s.deployAlias)
                                                            .map(x => x.deployAlias)
                                                        : []
                                                }
                                            />
                                        </div>
                                    ))}
                                </div>
                            </Input>
                        </>
                    )}
            </div>
        </>
    )
}